import { Menu, rem } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconArchive } from "@tabler/icons-react";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v1/colors";
import { ExportConsultationModal } from "#modules/quoteRequests/view/exportConsultation/ExportConsultationModal";
import { GenerateQuoteInfoModal } from "#modules/quoteRequests/view/GenerateQuoteInfoModal";
import { QuoteRequestActionsMenuItemExport } from "#modules/quoteRequests/view/QuoteRequestActionsMenuItemExport";
import { QuotesList } from "#modules/quoteRequests/view/QuotesList";
import { useQuoteRequestLinesCsvDownload } from "#modules/quoteRequests/view/useQuoteRequestLinesCsvDownload";
import { useUpdateArchiveQuoteRequest } from "#modules/quoteRequests/view/useUpdateArchiveQuoteRequest";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { quoteRequestAtom } from "#shared/view/components/AppShell/Atoms";

export const QuoteRequestActionsMenu = () => {
  const quoteRequest = useAtomValue(quoteRequestAtom);
  const { t } = useTranslation();

  const [pdfModalOpened, { open: openGenerateQuoteInfoModal, close: closeGenerateQuoteInfoModal }] =
    useDisclosure();

  const [
    exportConsultationModalOpened,
    { open: openExportConsultationModal, close: closeExportConsultationModal },
  ] = useDisclosure();

  const { updateArchiveQuoteRequest } = useUpdateArchiveQuoteRequest(quoteRequest);

  const { downloadCsv, canDownload } = useQuoteRequestLinesCsvDownload(quoteRequest);

  const handleArchivedQuoteRequest = () => {
    updateArchiveQuoteRequest({
      id: quoteRequest?.id || "",
      archived: quoteRequest ? !quoteRequest.isArchived : true,
    });
  };

  if (!quoteRequest) {
    return null;
  }

  return (
    <>
      <GenerateQuoteInfoModal opened={pdfModalOpened} onClose={closeGenerateQuoteInfoModal} />
      <ExportConsultationModal
        opened={exportConsultationModalOpened}
        onClose={closeExportConsultationModal}
        quoteRequest={quoteRequest}
      />

      <Menu shadow="md" width={"max-content"}>
        <Menu.Target>
          <ActionIcon size="lg">
            <Icon name="moreHorizontal" size={24} color={colors.gray[4]} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconArchive style={{ width: rem(14), height: rem(14) }} />}
            onClick={handleArchivedQuoteRequest}
          >
            {quoteRequest.isArchived
              ? t("quoteRequestLine.actions.unarchive")
              : t("quoteRequestLine.actions.archive")}
          </Menu.Item>

          <Menu.Item
            leftSection={<Icon name="pdf" size={14} />}
            onClick={() => openGenerateQuoteInfoModal()}
          >
            {t("quoteRequestLine.actions.generateQuote")}
          </Menu.Item>

          <Menu.Item
            leftSection={<Icon name="csv" size={14} />}
            onClick={downloadCsv}
            disabled={!canDownload}
          >
            {t("quoteRequestLine.actions.downloadCSV")}
          </Menu.Item>

          <QuoteRequestActionsMenuItemExport quoteRequestId={quoteRequest.id} />

          <Menu.Item
            leftSection={<Icon name="mailSend" size={14} />}
            onClick={openExportConsultationModal}
          >
            {t("quoteRequestLine.actions.exportConsultation.menuItem")}
          </Menu.Item>

          <QuotesList quoteRequestId={quoteRequest.id} />
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
